import Icon from './Icon.view';

export default Icon;
